'use client';

import { useExtensionFlow } from "@/widgets/ExtensionFlow/context/ExtensionFlowContext";

import { MEMBERSHIP_TYPE_EXCLUDED_QUERY_KEYS } from "@/common/components/SalesFlow/StepsContent/components/MembershipType/MembershipType.service";

import { MembershipTypeAnalyticsEvents, MembershipTypeProps } from "@/common/components/SalesFlow/StepsContent/components/MembershipType/MembershipType.interfaces";
import { AnalyticsAdapterEventTypes, AnalyticsAdapterType } from "@/common/types/datalayer.interfaces";

import MembershipType from "@/common/components/SalesFlow/StepsContent/components/MembershipType/MembershipType";
import { UrlParamKeys } from "@/common/utils/constants";


export default function ExtensionMembershipType({
    data,
    lang,
    step
}: Omit<MembershipTypeProps, 'analytics' | 'excludedQueryKeys'>) {
    const { pushToDataLayer } = useExtensionFlow();

    const excludedQueryKeys = [
        ...MEMBERSHIP_TYPE_EXCLUDED_QUERY_KEYS,
        UrlParamKeys.SkipPayment
    ];

    const analyticsAdapter: AnalyticsAdapterType<MembershipTypeAnalyticsEvents> = {
        track(event) {
            switch (event.type) {
                case AnalyticsAdapterEventTypes.FUNNEL_START: {
                    const { clubData, studioId } = event.payload;
                    pushToDataLayer({
                        event: 'funnel',
                        funnel_name: 'extension',
                        funnel_step_name: 'membership_type',
                        funnel_step: '3',
                        city: clubData.address.city.toLowerCase(),
                        studio_id: studioId,
                        studio_name: clubData.studioName
                            ?.toLowerCase()
                            .replace(/\s+/g, '_'),
                    });
                    break;
                }

                case AnalyticsAdapterEventTypes.DEFAULT_MEMBERSHIP_SELECTED: {
                    const {
                        clubData,
                        studioId,
                        membershipType,
                        accessLevel,
                    } = event.payload;

                    pushToDataLayer({
                        event: 'funnel',
                        funnel_name: 'extension',
                        funnel_step_name: 'membership_type',
                        funnel_step: '3',
                        membership_type: membershipType.toLowerCase(),
                        access_type: accessLevel.toLowerCase(),
                        city: clubData.address.city.toLowerCase(),
                        studio_id: studioId,
                        studio_name: clubData.studioName
                            ?.toLowerCase()
                            .replace(/\s+/g, '_'),
                    });
                    break;
                }
            }
        },
    };

    return (
        <MembershipType
            data={data}
            lang={lang}
            step={step}
            excludedQueryKeys={excludedQueryKeys}
            analytics={analyticsAdapter}
        />
    )
}